import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { ModalPanel, ModalSidebarContext } from '../../../../../../components/ModalSidebar'
import { DefaultSettingsContext } from '../../../default-settings/DefaultSettingsProvider'

const propTypes = {
  /**
   * Step of the modal to go to when the save fails and user clicks on 'back', usually first step of the modal
   */
  goBackTo: PropTypes.string.isRequired,
}

/**
 * Panel to show after onSubmit is called in the DefaultSettingsModalHelpers
 */
function SubmitSettingsPanel(props) {
  const { goBackTo } = props

  const { goToStep } = useContext(ModalSidebarContext)

  const { errors: validationErrors } = useFormikContext()

  const { errorCreatingEngageDefaultSettings, errorUpdatingEngageDefaultSettings } = useContext(DefaultSettingsContext)

  const hasErrors =
    !isEmpty(validationErrors) || errorCreatingEngageDefaultSettings || errorUpdatingEngageDefaultSettings
  const leftButton = hasErrors
    ? {
        label: 'GENERAL.BACK',
        variant: 'primary',
        onClick: () => goToStep(goBackTo),
      }
    : null

  return (
    <ModalPanel leftButton={leftButton} rightButton="close">
      <SubmitSettingsPanelContent
        errorSaving={errorCreatingEngageDefaultSettings || errorUpdatingEngageDefaultSettings}
        validationErrors={validationErrors}
      />
    </ModalPanel>
  )
}

function SubmitSettingsPanelContent(props) {
  const { errorSaving, validationErrors } = props // eslint-disable-line react/prop-types

  // formik runs the validation every time on submit
  // in this step the form should be already validated and good to go
  // however if anything happens show all errors here
  if (!isEmpty(validationErrors)) {
    return (
      <>
        <div>
          <i className="font-color-danger fas fa-circle-xmark me-2" />
          <span className="text-bold">
            <FormattedMessage id="GENERAL.MODAL_VALIDATION_FAILED" />
          </span>
        </div>
        <ul>
          {Object.entries(validationErrors).map(([key, value]) => (
            <li key={key}>
              {key}: {value}
            </li>
          ))}
        </ul>
      </>
    )
  }

  if (errorSaving) {
    return (
      <div>
        <i className="font-color-danger fas fa-circle-xmark me-2" />
        <span>
          <FormattedMessage id="GENERAL.ERROR" />
        </span>
      </div>
    )
  }

  // success case
  return (
    <div>
      <i className="font-color-primary fas fa-circle-check me-2" />
      <FormattedMessage id="DEFAULT_SETTINGS.DEFAULT_SETTINGS_SAVED" />
    </div>
  )
}

SubmitSettingsPanel.propTypes = propTypes

export default SubmitSettingsPanel
